import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    $("#issue_preferences .dropdown-item").each(function( index ) {
      var class_name = $( this ).text().toLowerCase().trim().replace(" ", "_");
      if($( this ).find("input").prop('checked') == true) {
        $("." + class_name).show();
      }else{
        $("." + class_name).hide();
      }
    });
  }

  set_display_preferences(event) {
    var field = $(event.target).parent().text().toLowerCase().trim();
    var checked = $(event.target).prop('checked');
    this.toggle_class(field, checked);
    var data = new FormData();
    data.append("field", field.trim());
    console.log(field)
    Rails.ajax({
      url: "/issues/update_display_preferences",
      type: 'POST',
      data: data,
      dataType: 'json',
      success: function(response) {
        console.log(response)
      }
    });
  }

  toggle_class(name, checked) {
    var class_name = name.trim().replace(" ", "_");
    if(checked == true)
      $("." + class_name).show();
    else
      $("." + class_name).hide();
  }

  openFilters() {
      // $("#collapseFilters").addClass("show");
      // $("#collapseFilters").removeClass("hide");
  }
  addMore(event) {
    $(event.target).hide();
    $("#other_tags").removeClass('d-none');
  }

  showAdditionalDataForm() {
    $("#additional-data").addClass("d-none");
    $("#additional-data-form").removeClass("d-none");
  }

  searchQuery(event) {
    let url = new URL(window.location.href);
    var keyword = $("#q").val();
    url.searchParams.set('q', keyword)
    if(keyword == null || keyword == '') { url.searchParams.delete("q") };
    window.location.href = url.href;
  }

  applyEngagement(event) {
    let url = new URL(window.location.href);
    var engagement_from = $("#engagementFrom").val();
    var engagement_to = $("#engagementTo").val();

    if (engagement_from && engagement_to) {
      url.searchParams.set('engagement_from', engagement_from);
      url.searchParams.set('engagement_to', engagement_to);
    } else if (engagement_from) {
      url.searchParams.set('engagement_from', engagement_from);
    } else if (engagement_to) {
      url.searchParams.set('engagement_to', engagement_to);
    } else {
      url.searchParams.delete('engagement_from')
      url.searchParams.delete('engagement_to')
    }
    window.location.href = url.href;
  }

  applyBooleanFilter(event) {
    let url = new URL(window.location.href);
    url.searchParams.delete('is_fact_checked');
    url.searchParams.delete('has_no_tags');
    url.searchParams.delete('is_reviewed');
    url.searchParams.delete('is_public');
    url.searchParams.delete('has_removed_content');
    url.searchParams.delete('has_no_narrative');

    for (var i = 0; i < $(".boolean-dropdown-filter:checked").length; i++) {
      var selected_items = $(".boolean-dropdown-filter:checked")[i].id
      console.log("fjskd", selected_items);
      if(selected_items == 'is_fact_checked') {
        url.searchParams.set(selected_items, true)
      } else if (selected_items == 'has_no_tags') {
        url.searchParams.set(selected_items, true)
      } else if (selected_items == 'is_reviewed') {
        url.searchParams.set(selected_items, true)
      } else if (selected_items == 'is_public') {
        url.searchParams.set(selected_items, true)
      } else if (selected_items == 'has_removed_content') {
        url.searchParams.set(selected_items, true)
      } else if (selected_items == 'has_no_narrative') {
        url.searchParams.set(selected_items, true)
      }
    }
    window.location.href = url.href;
  }

}
